import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { Row, Col } from 'react-flexbox-grid'
import { FormattedMessage, injectIntl } from 'react-intl'
import { CharField, TextField, DateTimeField, SingleSelectField } from 'components/forms'
import styles from './_workoutForm.css'
import * as userGear from 'services/userGear/selectors'
import * as userGearActions from 'services/userGear/actions'

const messages = {
  noGear: {
    id: 'workout.create.no_gear',
    defaultMessage: 'No Gear',
  },
}

const mapStateToProps = state => ({
  activeUserGearOptions: userGear.selectUserGearOptions(false)(state),
  allUserGearOptions: userGear.selectUserGearOptions(true)(state),
})

const mapDispatchToActions = {
  ...userGearActions,
}

export class Common extends Component {

  static propTypes = {
    fetchUserGear: PropTypes.func,
    userGearOptions: PropTypes.array,
    intl: PropTypes.object,
    defaultWorkout: PropTypes.object,
    mode: PropTypes.oneOf(['create', 'edit']),
    activeUserGearOptions: PropTypes.array,
    allUserGearOptions: PropTypes.array,
  }

  componentDidMount () {
    this.props.fetchUserGear()
  }

  getUserGearOptions () {
    const { intl, mode, defaultWorkout, activeUserGearOptions, allUserGearOptions } = this.props
    const isEditing = mode === 'edit'
    const defaultGearLink = defaultWorkout ? defaultWorkout.gear : null
    const gearOptions = isEditing ? allUserGearOptions : activeUserGearOptions
    const noGear = { label: intl.formatMessage(messages.noGear), value: '' }

    // preselect chosen gear if available
    let options = gearOptions
    if (isEditing && defaultGearLink) {
      options = gearOptions.map(opt => {
        if (opt.value === defaultGearLink) { opt.selected = true }
        return opt
      })
    }

    // finaly, tack on 'no gear' option and return
    return [ noGear, ...options ]
  }

  render () {
    const { defaultWorkout } = this.props
    const defaultStart = defaultWorkout ? defaultWorkout.startDate : moment()

    return (
      <div className={styles.box}>
        <Row>
          <Col xs={12} sm={6}>
            <CharField
              bold
              name='name'
              labelComponent={(
                <FormattedMessage
                  id='workouts.create.name'
                  defaultMessage='Workout name'
                />
              )}
            />
          </Col>
          <Col xs={12} sm={5} smOffset={1}>
            <DateTimeField
              bold
              required
              defaultValue={defaultStart}
              timeFormat={false}
              name='startDate'
              labelComponent={(
                <FormattedMessage
                  id='workouts.create.start_date'
                  defaultMessage='Date'
                />
              )}
              errorComponent={(
                <FormattedMessage
                  id='workouts.create.start_date_invalid'
                  defaultMessage='Invalid date. Format: MM/DD/YYY'
                />
              )}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={8}>
            <SingleSelectField
              bold
              name='gear'
              options={this.getUserGearOptions()}
              labelComponent={(
                <FormattedMessage
                  id='workouts.create.gear_used'
                  defaultMessage='Gear used'
                />
              )}
            />
          </Col>
        </Row>

        <Row>
          <Col xs={12} sm={5}>
            <DateTimeField
              bold
              dateFormat={false}
              name='startTime'
              placeholder='HH:MM AM'
              defaultValue={defaultStart}
              labelComponent={(
                <FormattedMessage
                  id='workouts.create.start_time'
                  defaultMessage='Start time'
                />
              )}
              errorComponent={(
                <FormattedMessage
                  id='workouts.create.start_time_invalid'
                  defaultMessage='Invalid time. Format: HH:MM AM (or PM)'
                />
              )}
            />
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <TextField
              bold
              slim
              name='notes'
              labelComponent={(
                <FormattedMessage
                  id='workouts.create.how_did_it_go'
                  defaultMessage='How did it go?'
                />
              )}
            />
          </Col>
        </Row>

      </div>
    )
  }

}

export const IntlWrapper = injectIntl(Common)
export default connect(mapStateToProps, mapDispatchToActions)(IntlWrapper)




// WEBPACK FOOTER //
// ./src/components/workouts/WorkoutForm/Common.jsx